// Announcement bar scrolling height & Header height

const announcementBar = document.querySelector(".announcement-bar-section");

function updateVisibleHeight() {
  if (!announcementBar) return; // Safety: don't crash if bar doesn't exist
  const rect = announcementBar.getBoundingClientRect();
  const visible = Math.max(
    0,
    Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
  );
  document.documentElement.style.setProperty('--announcement-visible-height', Math.round(visible) + "px");
}

window.addEventListener("scroll", updateVisibleHeight);
window.addEventListener("resize", updateVisibleHeight);
updateVisibleHeight();

document.documentElement.style.setProperty('--window-scroll-height', window.scrollY + "px");
window.addEventListener("scroll", () => {
  document.documentElement.style.setProperty('--window-scroll-height', window.scrollY + "px");
});
window.addEventListener('load', () => {

  const header_heigt = document.querySelector(".section-header");
  if (header_heigt) {
    const headerHeight = Math.round(header_heigt.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--header-height',`${headerHeight}px`);
  }
});


class CollectionCarousel extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    const autoplayEnabled = this.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 3000;

    const swiperEl = this.querySelector(".js-collection-carousel");
    if (!swiperEl) return;

    const swiperConfig = {
      slidesPerView: 1.7,
      spaceBetween: 10,
      slidesOffsetAfter: 30,
      a11y: true,
      mousewheel: {
        forceToAxis: true, // Prevents vertical page scroll when scrolling horizontally
        releaseOnEdges: true, // Allows page to scroll normally when reaching the end of the carousel
      },
      pagination: {
        el: this.querySelector(".collection-carousel-pagination"),
        type: "progressbar",
      },
      navigation: {
        nextEl: this.querySelector(".collection-carousel-button-next"),
        prevEl: this.querySelector(".collection-carousel-button-prev"),
      },
      breakpoints: {
        769: {
          slidesPerView: 2.5,
          spaceBetween: 20,
          slidesOffsetAfter: 40,
        },
        1024: {
          slidesPerView: 3.284,
          spaceBetween: 20,
          slidesOffsetAfter: 40,
        },
      },
    };

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    this.swiper = new Swiper(swiperEl, swiperConfig);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get("collection-carousel")) {
  customElements.define("collection-carousel", CollectionCarousel);
}

class CollectionProductCarousel extends HTMLElement {
  constructor() {
    super();
			
			var swiper = new Swiper(".js-collection-product-carousel", {
				slidesPerView: 1.7,
				spaceBetween:10,
				slidesOffsetAfter:30,
        mousewheel: {
          forceToAxis: true, 
          releaseOnEdges: true,
        },
         navigation: {
            nextEl: '.product-carousel-button-next',
            prevEl: '.product-carousel-button-prev',
          },
        a11y: true,
				breakpoints: {
					769: {
						slidesPerView:  2.5,
						spaceBetween:  10,
						slidesOffsetAfter: 40,
					},
					1024: {
						slidesPerView: 3.227,
						spaceBetween:20,
						slidesOffsetAfter:40,
					}
				}
			});

  }
}

customElements.define('collection-product-carousel', CollectionProductCarousel);


class WhyChooseUs extends HTMLElement {
  constructor() {
    super();
			
			var swiper = new Swiper(".js-why-choose-us", {
				slidesPerView: 1.7,
				spaceBetween:10,
				slidesOffsetAfter:30,
        a11y: true,
				breakpoints: {
					769: {
						slidesPerView: 2.5,
						spaceBetween:  20,
						slidesOffsetAfter: 40,
					},
					1024: {
						slidesPerView: 3.8,
						spaceBetween: 20,
						slidesOffsetAfter:40,
					},
					1400:{
						slidesPerView: 4.1126,
						spaceBetween: 20,
						slidesOffsetAfter:0,
					}
				}
			});

  }
}

customElements.define('why-choose-us', WhyChooseUs);


class CustomerStories extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    const autoplayEnabled = this.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 100) || 3000;

    const swiperEl = this.querySelector(".js-customer-stories");
    if (!swiperEl) return;

    const swiperConfig = {
      slidesPerView: 1.1799,
      spaceBetween: 5,
      a11y: true,
      loop: true,
      breakpoints: {
        769: {
          slidesPerView: 2.5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3.1555,
          spaceBetween: 10,
        },
      }
    };

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    this.swiper = new Swiper(swiperEl, swiperConfig);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('customer-stories', CustomerStories);


class CollectionGallery extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    const autoplayEnabled = this.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 100) || 3000;

    const swiperEl = this.querySelector(".js-collection-gallery");
    if (!swiperEl) return;

    const swiperConfig = {
      slidesPerView: 2.2419,
      spaceBetween: 5,
      a11y: true,
      loop: true,

      pagination: {
        el: this.querySelector(".collection-gallery-pagination"),
        type: "progressbar",
      },

      breakpoints: {
        769: {
          slidesPerView: 2.5,
          spaceBetween: 5,
        },
        1024: {
          slidesPerView: 4.0569,
          spaceBetween: 10,
        }
      }
    };

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    this.swiper = new Swiper(swiperEl, swiperConfig);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('collection-gallery', CollectionGallery);


class ShopTheLook extends HTMLElement {
  constructor() {
    super();
      const swiperNextBtn = this.querySelector(".shop-look-slider-buttons .next-buttton");
      const swiperprevBtn = this.querySelector(".shop-look-slider-buttons .prev-buttton");

      const mainSliderNext =  this.querySelector(".js-shop-look-product-carousel .swiper-button-next");
      const mainSliderPrev =  this.querySelector(".js-shop-look-product-carousel .swiper-button-prev");

        swiperNextBtn?.addEventListener("click", () => {
            mainSliderNext.click(); 
        });

        swiperprevBtn?.addEventListener("click", () => {
            mainSliderPrev.click(); 
        });
        
      
      var swiper = new Swiper(".js-shop-look-product-carousel", {
        slidesPerView: "auto",
        spaceBetween: 20,
        a11y: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next.shop-the-look-next",
          prevEl: ".swiper-button-prev.shop-the-look-prev",
        },

        pagination: {
          el: ".swiper-pagination.shop-look-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '" data-index="' + (index + 1) + '">' + "</span>";
          },
        },
      });

        const allSwiperBullets = this.querySelectorAll(".swiper-pagination.shop-look-pagination .swiper-pagination-bullet");
        const imageSwiperBullets = this.querySelectorAll(".shop-look-dots .dot");

        allSwiperBullets.forEach(bullet => {
          const bulletIndex = bullet.getAttribute("data-index");
          imageSwiperBullets.forEach(dot => {
            const dotIndex = dot.getAttribute("data-dot-index");
            if ( bullet.classList.contains("swiper-pagination-bullet-active") && bulletIndex == dotIndex ) { 
              dot.classList.add("active"); 
            }
            dot.addEventListener("click", e => {
              const clickedIndex = e.currentTarget.getAttribute("data-dot-index");
              if (clickedIndex == bulletIndex) {
                bullet.click();
              }
            });
          });
        });


        swiper.on('slideChange', () => {
          const activeIndex = swiper.realIndex + 1;
          imageSwiperBullets.forEach(dot => dot.classList.remove("active"));
          const activeDot = this.querySelector(`.shop-look-dots .dot[data-dot-index="${activeIndex}"]`);
          if (activeDot) activeDot.classList.add("active");
        });


      const openerButtons = this.querySelectorAll(".shop-the-look__opener");
      const mainProductPart = this.querySelector(".shop-the-look-products");
      const closeButton = this.querySelector(".pop-up-close");

      const mediaQuery = window.matchMedia('(max-width: 768px)');

      const enableMobileBehaviour = () => {
        if (!openerButtons.length || !mainProductPart) return;

        openerButtons.forEach((openerButton) => {
          openerButton.addEventListener('click', openHandler);
        });

        mainProductPart.addEventListener('click', stopPropagationHandler);
        document.addEventListener('click', closeHandler);

        if (closeButton) {
          closeButton.addEventListener('click', closeHandler);
        }
      };

      const disableMobileBehaviour = () => {
        openerButtons.forEach((openerButton) => {
          openerButton.removeEventListener('click', openHandler);
        });

        mainProductPart.removeEventListener('click', stopPropagationHandler);
        document.removeEventListener('click', closeHandler);

        if (closeButton) {
          closeButton.removeEventListener('click', closeHandler);
        }

        mainProductPart.classList.remove('active');
      };

      const openHandler = (e) => {
        e.stopPropagation();
        mainProductPart.classList.toggle('active');
      };

      const stopPropagationHandler = (e) => {
        e.stopPropagation();
      };

      const closeHandler = () => {
        mainProductPart.classList.remove('active');
      };

      if (mediaQuery.matches) {
        enableMobileBehaviour();
      }

      mediaQuery.addEventListener('change', (e) => {
        if (e.matches) {
          enableMobileBehaviour();
        } else {
          disableMobileBehaviour();
        }
      });

  }
}

customElements.define('shop-the-look', ShopTheLook);


class AttachmentField extends HTMLElement {
  connectedCallback() {
  this.inputField = this.querySelector("input");
  this.placeholder = this.querySelector(".attachment-place-holder-text");
  this.uploadButton = this.querySelector(".upload-button");
  this.cancelButton = this.querySelector(".cancle-button");

  this.uploadButton.addEventListener("click", () => this.inputField.click());

  this.inputField.addEventListener("change", () => {
    const file = this.inputField.files[0];
    if (file) {
      this.placeholder.textContent = file.name;
      this.cancelButton.classList.remove("hidden");
      this.uploadButton.classList.add("hidden");
    }
  });

  this.cancelButton.addEventListener("click", () => {
    this.inputField.value = "";
    this.placeholder.textContent = "Attachments *";
    this.cancelButton.classList.add("hidden");
    this.uploadButton.classList.remove("hidden");
  });
}
}

customElements.define('attachment-field', AttachmentField);

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.currentProductHandle = this.dataset.productId;

    this.trackCurrentProduct();
    this.renderProducts();
  }

  trackCurrentProduct() {
    if (!this.currentProductHandle) return;

    let viewedProducts =
      JSON.parse(localStorage.getItem('recently_viewed_products')) || [];
    viewedProducts = viewedProducts.filter(
      handle => handle !== this.currentProductHandle
    );
    viewedProducts.unshift(this.currentProductHandle);
    viewedProducts = viewedProducts.slice(0, 12);

    localStorage.setItem(
      'recently_viewed_products',
      JSON.stringify(viewedProducts)
    );
  }

  getViewedProducts() {
    try {
      return (
        JSON.parse(
          localStorage.getItem('recently_viewed_products')
        ) || []
      );
    } catch (e) {
      return [];
    }
  }

  async renderProducts() {
    const viewedProducts = this.getViewedProducts().filter(
      handle => handle !== this.currentProductHandle
    );

    if (!viewedProducts.length) {
      this.style.display = 'none';
      return;
    }

    const wrapper = this.querySelector(
      '#recently-viewed-wrapper'
    );

    if (!wrapper) return;
    const cards = await Promise.all(
      viewedProducts.map(handle =>
        this.fetchProductCard(handle)
      )
    );

    const validCards = cards.filter(Boolean);

    if (!validCards.length) {
      this.style.display = 'none';
      return;
    }
    wrapper.innerHTML = validCards
      .map(
        card => `
          <div class="swiper-slide main-product">
            ${card}
          </div>
        `
      )
      .join('');
    document.dispatchEvent(
      new CustomEvent('recentlyViewedLoaded')
    );
  }

  async fetchProductCard(handle) {
    try {
      const response = await fetch(
        `/products/${handle}?view=card`
      );

      if (!response.ok) return null;

      return await response.text();
    } catch (error) {
      console.error(
        'Recently viewed fetch error:',
        error
      );

      return null;
    }
  }
}

if (!customElements.get('recently-viewd-products')) {
  customElements.define(
    'recently-viewd-products',
    RecentlyViewedProducts
  );
}

class LoadMore extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('#load-more-btn');
    this.gridId = this.dataset.grid;
    this.grid = document.getElementById(this.gridId);

    this.currentPage = Number(this.dataset.currentPage);
    this.productsPerPage = Number(this.dataset.productsPerPage);
    this.totalItems = Number(this.dataset.totalItems);
    
    // Calculate total pages
    this.totalPages = Math.ceil(this.totalItems / this.productsPerPage);

    if (this.button && this.grid) {
      this.button.addEventListener('click', () => this.loadMore());
    }
  }

  loadMore() {
    if (this.currentPage >= this.totalPages) return;

    const nextPage = this.currentPage + 1;
    const params = new URLSearchParams(window.location.search);
    params.set('page', nextPage);

    const url = `${window.location.pathname}?${params.toString()}`;

    this.setLoading(true);

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll(`#${this.gridId} > li`);

        if (!newItems.length) {
          this.remove();
          return;
        }

        newItems.forEach(item => this.grid.appendChild(item));

        this.currentPage = nextPage;
        this.dataset.currentPage = nextPage;

        if (this.currentPage >= this.totalPages) {
          this.remove();
        } else {
          this.setLoading(false);
        }
      })
      .catch(err => {
        console.error('Load more failed', err);
        this.setLoading(false);
      });
  }

  setLoading(isLoading) {
    this.button.disabled = isLoading;
    this.button.textContent = isLoading ? 'Loading…' : 'View More';
  }
}

customElements.define('load-more-products', LoadMore);

document.querySelectorAll(".desk-scroll-wrapper").forEach((slider) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("active");

    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;

    slider.scrollLeft = scrollLeft - walk;
  });
});


class SelectedVariantBar extends HTMLElement {
  constructor() {
    super();
    this.variantText = this.querySelector(".selected-variant__title");
  }

  connectedCallback() {
    setTimeout(() => this.updateVariant(), 0);

    document.addEventListener("change", (event) => {
      if (
        event.target.matches('variant-selects [type="radio"]') ||
        event.target.matches('variant-selects select')
      ) {
        this.updateVariant();
      }
    });
  }

  updateVariant() {

    const selectedOptions = [];

    const fieldsets = document.querySelectorAll("variant-selects fieldset");

    fieldsets.forEach((fieldset) => {
      const checked = fieldset.querySelector("input:checked");
      if (checked) {
        selectedOptions.push(checked.value);
      }
    });

    const selects = document.querySelectorAll("variant-selects select");

    selects.forEach((select) => {
      if (select.value) {
        selectedOptions.push(select.value);
      }
    });

    if (this.variantText) {
      this.variantText.textContent = selectedOptions.join(" | ");
    } else {
      console.error(".selected-variant__title not found inside", this);
    }
  }
}

customElements.define("selected-variant-values", SelectedVariantBar);

class BuyNowButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
  }

  connectedCallback() {
    if (!this.button) return;

    this.button.addEventListener(
      "click",
      this.onClick.bind(this)
    );

    this.syncButtonState();

    document.addEventListener("change", () => {
      setTimeout(() => {
        this.syncButtonState();
      }, 100);
    });
  }

  syncButtonState() {
    const addToCartButton = document.querySelector(
      '.product-form button[name="add"]'
    );

    if (!addToCartButton) return;

    this.button.disabled = addToCartButton.disabled;
  }

  async onClick() {
    try {
      this.button.setAttribute("disabled", true);

      const form = this.closest("form");

      if (!form) return;

      const formData = new FormData(form);

      await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      window.location.href = "/checkout";

    } catch (error) {
      console.error("Buy Now Error:", error);

    } finally {
      this.syncButtonState();
    }
  }
}

customElements.define("buy-now-button",BuyNowButton);

class ProductTitle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateTitles();
  }

  updateTitles() {
    this.querySelectorAll(".product-title-dynamic").forEach((titleEl) => {

      if (titleEl.dataset.processed) return;

      titleEl.innerHTML = titleEl.innerHTML.replace(
        /(\d+)/g,
        '<span style="font-family: var(--font-body-family)">$1</span>'
      );

      titleEl.dataset.processed = "true";
    });
  }
}

customElements.define("product-title", ProductTitle );

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector(
      ".scrolling-promotion__track"
    );
  }

  connectedCallback() {
    this.cloneItems();

    this.addEventListener("mouseenter", () => {
      this.track.style.animationPlayState = "paused";
    });

    this.addEventListener("mouseleave", () => {
      this.track.style.animationPlayState = "running";
    });
  }

  cloneItems() {
    const items = [...this.track.children];

    items.forEach((item) => {
      const clone = item.cloneNode(true);

      this.track.appendChild(clone);
    });
  }
}

customElements.define( "scrolling-promotion", ScrollingPromotion );

class AnimateAccordion extends HTMLElement {
  constructor() {
    super();
    this.details  = this.querySelector('details');
    this.summary  = this.querySelector('summary');
    this.content  = this.querySelector('.details-content');
    this.isAnimating = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    if (this.isAnimating) return;

    if (this.details.open) {
      this.shrink();
    } else {
      this.closeOthers();
      this.open();
    }
  }

  closeOthers() {
    document.querySelectorAll('acordion-animated').forEach(acc => {
      if (acc !== this && acc.details.open && !acc.isAnimating) {
        acc.shrink();
      }
    });
  }

  shrink() {
    this.isAnimating = true;

    // Lock current height explicitly
    this.content.style.height = this.content.scrollHeight + 'px';
    this.content.style.overflow = 'hidden';
    this.content.style.transition = 'height 350ms ease';

    // Force reflow so browser registers the starting height
    this.content.offsetHeight;

    // Now animate to 0
    this.content.style.height = '0px';

    this.content.addEventListener('transitionend', () => {
      this.details.open = false;
      this.content.style.height = '';
      this.content.style.overflow = '';
      this.content.style.transition = '';
      this.isAnimating = false;
    }, { once: true });
  }

  open() {
    this.isAnimating = true;
    this.details.open = true;

    // Measure target height
    this.content.style.height = '0px';
    this.content.style.overflow = 'hidden';
    this.content.style.transition = 'none';

    // Force reflow
    this.content.offsetHeight;

    const targetHeight = this.content.scrollHeight + 'px';

    this.content.style.transition = 'height 350ms ease';
    this.content.style.height = targetHeight;

    this.content.addEventListener('transitionend', () => {
      this.content.style.height = '';
      this.content.style.overflow = '';
      this.content.style.transition = '';
      this.isAnimating = false;
    }, { once: true });
  }
}

customElements.define('acordion-animated', AnimateAccordion);

function applyMobileWrapper() {
  const wrapper = document.querySelector('.footer__blocks-wrapper');
  const item3 = wrapper.querySelector('.item-3');
  const item4 = wrapper.querySelector('.item-4');
  const existingMobileWrapper = wrapper.querySelector('.footer-mobile-wrapper');

  if (window.innerWidth <= 768) {
    if (existingMobileWrapper) return;
    const mobileWrapper = document.createElement('div');
    mobileWrapper.classList.add(
      'footer-mobile-wrapper',
      'flex',
      'justify-space-btwn',
      'gap-10'
    );

    wrapper.insertBefore(mobileWrapper, item3);

    mobileWrapper.appendChild(item3);
    mobileWrapper.appendChild(item4);

  } else {
    if (!existingMobileWrapper) return;

    wrapper.insertBefore(item3, existingMobileWrapper);
    wrapper.insertBefore(item4, existingMobileWrapper);
    existingMobileWrapper.remove();
  }
}
applyMobileWrapper();
window.addEventListener('resize', applyMobileWrapper);



class ActiveFilterCount extends HTMLElement {
  constructor() {
    super();

    this.countElement = this.querySelector(
      "[data-filter-count]"
    );
  }

  connectedCallback() {
    this.update();

    window.addEventListener(
      "popstate",
      this.update.bind(this)
    );

    const originalPushState = history.pushState;
    history.pushState = (...args) => {
      originalPushState.apply(history, args);
      this.update();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args);
      this.update();
    };

    document.addEventListener(
      "click",
      this.handleFilterClick.bind(this)
    );
  }

  handleFilterClick() {
    setTimeout(() => {
      this.update();
    }, 500);
  }

  update() {
    if (!this.countElement) return;

    const params = new URLSearchParams(
      window.location.search
    );

    const activeFilters = new Set();

    params.forEach((value, key) => {
      if (!key.startsWith("filter.")) return;

      if (key.includes(".price.")) {
        activeFilters.add("price");
      } else {
        activeFilters.add(key);
      }
    });

    const count = activeFilters.size;

    this.countElement.textContent = count;

    this.classList.toggle(
      "hidden",
      count === 0
    );
  }
}

if (
  !customElements.get(
    "active-filter-count"
  )
) {
  customElements.define(
    "active-filter-count",
    ActiveFilterCount
  );
}


class HoverdSubcategoryMenu extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.submenu = this.details.querySelector('.header__submenu');
    this.currentAnimation = null;

    this.addEventListener('mouseenter', () => this.open());
    this.addEventListener('mouseleave', () => this.close());

    const summary = this.details.querySelector('summary');
    summary?.addEventListener('click', (e) => {
      if (window.matchMedia('(hover: hover)').matches) {
        e.preventDefault();
      }
    });
  }

  open() {
    if (!this.submenu) return;
    this.currentAnimation?.cancel();

    this.details.setAttribute('open', '');

    this.currentAnimation = this.submenu.animate(
      [
        { opacity: 0, transform: 'translateY(6px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ],
      {
        duration: 400,
        easing: 'ease',
        fill: 'forwards'
      }
    );
  }

  close() {
    if (!this.submenu) return;

    this.currentAnimation?.cancel();

    this.currentAnimation = this.submenu.animate(
      [
        { opacity: 1, transform: 'translateY(0)' },
        { opacity: 0, transform: 'translateY(6px)' }
      ],
      {
        duration: 400,
        easing: 'ease',
        fill: 'forwards'
      }
    );

    this.currentAnimation.onfinish = () => {
      this.details.removeAttribute('open');
    };
  }
}

customElements.define('hoverd-subcategory-menu', HoverdSubcategoryMenu);


class DynamicButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.applyStyles();

    const observer = new MutationObserver(() => {
      this.applyStyles();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  applyStyles() {
    const button = document.querySelector('.shopify-payment-button__button');

    if (!button) return;

    button.style.setProperty('background-color', '#324775', 'important');
    button.style.setProperty('font-family', 'var(--font-body-family)', 'important');
    button.style.setProperty('font-weight', '400', 'important');
    button.style.setProperty('font-size', '1.4rem', 'important');
    button.style.setProperty('line-height', '1.8rem', 'important');
    button.style.setProperty('letter-spacing', '0', 'important');
    button.style.setProperty('padding', '1rem 2rem', 'important');
    button.style.setProperty('color', 'rgb(var(--color-button-text))', 'important');
  }
}

customElements.define('dynamic-button', DynamicButton);


